<div *ngIf="this.isLoading" class="se-loader"></div>
<div class="main-div p-2">
  <div class="top-div">
    <div class="filter-sec pt-2">
      <input type="text" title={{labels.mobileSearch|translate}} aria-label="search" class="input-globalsearch" size="50" placeholder={{labels.search|translate}} (input)="dt.filterGlobal($event.target.value, 'contains')">
      <a class="SearchLink">
        <em class="fa fa-search SearchIcon"></em>
      </a>
    </div>
  </div>
  <div class="tbl-section">
    <div class="rectangle-grid">
      <p-table #dt [columns]="cols" [value]="mobileInfo" [paginator]="isPagination" [rows]="10"  [globalFilterFields]="['mobileUId','mobileModel','mobileOS','mobileOSVersion']">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th scope="col" class="width3em">#</th>
            <th scope="col" *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'display': col.display}">
              {{col.header| translate}}
              <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <th scope="col">{{ labels.actions | translate }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
          <tr class="rowHeight">

            <td>
              {{i+1}}
            </td>
            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
              <span *ngIf="col.field === 'mobileOS'">
                {{rowData[col.field] + ' | ' + rowData.mobileOSVersion}}
              </span>
              <span *ngIf="col.field !== 'mobileOS' && col.field !== 'issuedOn'" appendTo="target " class="relativePosition">
                {{rowData[col.field]}}
              </span>
              <span *ngIf="col.field === 'issuedOn'">
                {{rowData[col.field] | date : 'dd-MM-yyyy HH:mm' }}
              </span>

            </td>
            <td>
              <img src="assets/delete.svg" class="icon-action deviceDel" (click)="DeleteUserDeveice(rowData)" height="29" width="29" alt="delete"
                   (keyup)="DeleteUserDeveice(rowData)"
                   (keypress)="DeleteUserDeveice(rowData)"
                   (keydown)="DeleteUserDeveice(rowData)" />
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr *ngIf="noData">
            <td [attr.colspan]="columns.length+1">
              {{labels.noRecords | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

</div>

<div class="se-dialog " *ngIf="showDeletemodal ">
  <div class="se-dialog-holder ">
    <div class="se-complex-header se-warning ">
      <h3 class="se-dialiog-title ">{{this.labels.deleteDevicehead|translate}} : {{mobileName}}</h3>
    </div>
    <div class="se-dialog-body se-dialog-body-delete ">
      <div *ngIf="this.isLoading " class="se-loader "></div>
      {{this.messages.deleteDevice| translate}}

    </div>
    <div class="se-dialog-footer ">
      <button class="se-button " (click)="close() ">{{labels.no | translate}}</button>
      <button class="se-button " (click)="onConfirm() ">{{labels.yes | translate}}</button>
    </div>

  </div>
</div>


<template ngbModalContainer>
</template>
<p-toast class="mt10" position="top-center" key="success"></p-toast>
<p-toast class="mt10" position="top-center" key="error"></p-toast>
<p-toast position="center " key="c " (onClose)="onReject()" [baseZIndex]="5000 ">

</p-toast>
